import { IonPage } from '@ionic/react'

import { ManagementOrderCreateView } from '@apps-common/apps/portal/pages/orders/pages/create/components/management'
import { PageTitle } from '@apps-common/components/common/portal-title'
import { UnauthorizedCard } from '@apps-common/components/common/UnauthorizedCard'
import { Header, LayoutContainer, LayoutPadding } from '@apps-common/components/layout'
import { Breadcrumbs, Navbar } from '@apps-common/components/navigation'
import { AUTH_CLAIMS, Authorization } from '@apps-common/lib'
import { ROUTE_CREATE_ORDER } from '@apps-radionet-portal/config/private-routes'

export const OrderCreatePage = () => (
  // const { orderId } = useParams<{ orderId: string }>()

  <IonPage>
    <Header>
      <Navbar showBack transparent icons={[]} />
      <Breadcrumbs route={ROUTE_CREATE_ORDER} />
      <PageTitle>Create order</PageTitle>
    </Header>
    <LayoutContainer>
      <LayoutPadding>
        <Authorization
          roles={AUTH_CLAIMS.managementAdmin.roles}
          scopes={AUTH_CLAIMS.managementAdmin.scopes}
          notAuthorizedFallback={<UnauthorizedCard />}
        >
          <ManagementOrderCreateView />
        </Authorization>
      </LayoutPadding>
    </LayoutContainer>
  </IonPage>
)
